import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, MessageCircle, Phone, Mail, ArrowLeft, Home as HomeIcon } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { SITE } from "@/lib/site";

export default function Danke() {
  // Google Ads / GTM Conversion: fire dataLayer event on page load
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "lead_form_submit",
        page: "/danke",
      });
      // If gtag is configured, also fire direct conversion event
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", { send_to: "AW-16867023480/7Cp6CKy784ocEPi06eo-" });
      }
    }
  }, []);

  const handleWhatsAppClick = () => {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "whatsapp_click", source: "danke_page" });
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", { send_to: "AW-16867023480/7Cp6CKy784ocEPi06eo-" });
      }
    }
  };

  return (
    <div data-testid="danke-page" className="min-h-screen bg-[#f5f1ea] text-[#2b2620] font-body">
      <Header />
      <main className="pt-32 pb-20">
        <div className="max-w-2xl mx-auto px-5 sm:px-8">
          {/* Success card */}
          <div className="bg-white border border-black/[0.06] rounded-3xl p-8 sm:p-12 text-center shadow-[0_30px_60px_-30px_rgba(30,31,37,0.18)]">
            <div className="w-20 h-20 mx-auto rounded-full bg-[#f5f1ea] border border-black/[0.08] flex items-center justify-center text-[#2b2620]" data-testid="danke-check-icon">
              <CheckCircle2 className="w-10 h-10" strokeWidth={1.5} />
            </div>

            <h1 className="mt-7 font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-[#2b2620]" data-testid="danke-headline">
              Vielen Dank für Ihre Anfrage.
            </h1>

            <p className="mt-5 text-lg text-[#4a3f36] leading-relaxed">
              Ihre Nachricht ist bei mir eingegangen. Ich melde mich schnellstmöglich bei Ihnen zurück.
            </p>

            <p className="mt-4 text-base text-[#6b5f52] leading-relaxed">
              Falls es besonders dringend ist, können Sie mir auch direkt per WhatsApp schreiben.
            </p>

            <a
              href={SITE.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleWhatsAppClick}
              data-testid="danke-whatsapp-button"
              data-conversion="whatsapp_click"
              className="mt-8 inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-[#25D366] text-white font-semibold hover:bg-[#1ebe57] transition-colors"
            >
              <MessageCircle className="w-5 h-5" />
              Direkt per WhatsApp schreiben
            </a>

            <div className="mt-10 pt-8 border-t border-black/[0.06] grid grid-cols-1 sm:grid-cols-2 gap-3">
              <a
                href={SITE.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleWhatsAppClick}
                data-testid="danke-contact-phone"
                className="flex items-center justify-center gap-3 px-4 py-3 rounded-2xl border border-black/[0.08] hover:bg-black/[0.03] transition-colors text-sm text-[#2b2620]"
              >
                <Phone className="w-4 h-4" /> {SITE.phone}
              </a>
              <a
                href={`mailto:${SITE.email}`}
                data-testid="danke-contact-email"
                className="flex items-center justify-center gap-3 px-4 py-3 rounded-2xl border border-black/[0.08] hover:bg-black/[0.03] transition-colors text-sm text-[#2b2620]"
              >
                <Mail className="w-4 h-4" /> {SITE.email}
              </a>
            </div>

            <Link
              to="/"
              data-testid="danke-back-home"
              className="mt-10 inline-flex items-center gap-2 text-sm text-[#6b5f52] hover:text-[#2b2620] transition-colors"
            >
              <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
            </Link>
          </div>

          <p className="mt-8 text-center text-xs text-[#8a7f70]">
            Antwort i. d. R. innerhalb von 24 Stunden &middot; SSL-verschlüsselt &middot; Diskrete Bearbeitung
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
